import styled from "@emotion/styled";
import { fontAngkor, fontFredoka, theme } from "@product/scmp-sdk";

import { setFullViewportWidthStyles } from "shared/lib/styles";

import HomeIcon from "./home.svg?url";
import Picture from "./picture.svg?url";

export const Container = styled.div`
  ${setFullViewportWidthStyles()}
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;

  padding-block: 48px;

  ${theme.breakpoints.up("largeDesktop")} {
    gap: 0;

    padding-block: 72px;
  }
`;

export const Title = styled.div`
  padding-inline: 32px;

  color: #1b4191;
  font-weight: 400;
  font-size: 84px;
  font-family: ${fontAngkor};
  line-height: 56px;
  letter-spacing: -1.68px;
  text-align: center;

  ${theme.breakpoints.up("largeDesktop")} {
    font-size: 168px;
    line-height: 168px;
    letter-spacing: -3.36px;
  }
`;

export const Description = styled.div`
  padding-inline: 32px;

  color: #555555;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontFredoka};
  line-height: 140%;
  letter-spacing: -0.32px;
  text-align: center;

  ${theme.breakpoints.up("largeDesktop")} {
    inline-size: 422px;
    padding-inline: 0;

    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0;
  }
`;

export const Content = styled.div`
  inline-size: 100%;
  max-inline-size: 348px;
  margin-inline: 14px;

  background-image: url(${Picture});
  background-size: cover;

  aspect-ratio: 348/154;
  ${theme.breakpoints.up("largeDesktop")} {
    max-inline-size: 594px;
    aspect-ratio: 594/263;

    margin-block: 32px;
  }
`;

export const Home = styled.span`
  display: inline-block;

  inline-size: 24px;
  block-size: 24px;

  background-image: url(${HomeIcon});
  background-size: cover;
`;

export const Button = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: 0.54px;
`;
